<template>
    <div>
        <div class="columns toolbar-box">
            <div class="column is-2">
                <h1 class="title is-6-tablet is-2-desktop is-3 between-center">
                    <span>
                        <span>Tasks by Location</span>
                        <a href="#" @click.prevent="isTableSettingsModalActive = true" class="gear">
                            <o-icon pack="fa" icon="gear" size="is-small"/>
                        </a>
                    </span>
                </h1>
            </div>
            <div class="column is-6-tablet is-2-desktop">
                <o-field>
                    <o-select placeholder="Task Type" v-model="filters.type" :expanded="true" @update:modelValue="fetchPaginatedData(true)">
                        <option value="">Select Type</option>
                        <option
                                v-for="taskType in taskTypes"
                                :value="taskType.id"
                                :key="taskType.id"
                        >
                            {{ taskType.name }}
                        </option>
                    </o-select>
                </o-field>
            </div>
            <div class="column is-6-tablet is-2-desktop">
                <o-field>
                    <o-input
                            type="search"
                            v-model="filters.title"
                            placeholder="Title"
                            icon="search"
                            @update:modelValue="fetchPaginatedData(true)"
                    ></o-input>
                </o-field>
            </div>
            <div class="column is-6-tablet is-2-desktop">
                <o-field>
                    <autocomplete-select
                            type="user"
                            track="id"
                            field-name="full_name"
                            placeholder="Search by User"
                            v-model="filters.assignee_id"
                            @update:modelValue="fetchPaginatedData()"
                    />
                </o-field>
            </div>
            <div class="column is-6-tablet is-4-desktop action-box">
                <div class="field is-grouped is-grouped-right">
                    <p v-if="isResetFiltersButtonVisible" class="control">
                        <a @click.prevent="handleResetFilters" class="button is-info"><span>Reset filters</span></a>
                    </p>
                    <p v-if="isDeleteSelectedButtonVisible" class="control">
                        <a @click.prevent="confirmCustomDelete" class="button is-danger"><span>Delete selected</span></a>
                    </p>
                    <!--<p class="control">-->
                        <!--<a @click.prevent="isCalendarModalActive = true" class="button is-info"><span>View in Calendar</span></a>-->
                    <!--</p>-->
                    <p class="control">
                        <router-link :to="newTaskRoute" class="button is-info" ><span class="icon"><i class="icm-new"></i></span><span>New</span></router-link>
                    </p>
                </div>
            </div>
        </div>
        <div class="columns toolbar-box">
            <div class="column is-offset-2 is-6-tablet is-2-desktop">
                <o-field>
                    <autocomplete-select
                            type="category"
                            placeholder="Search by Category"
                            v-model="filters.category_id"
                            @update:modelValue="fetchPaginatedData()"
                    />
                </o-field>
            </div>
            <div class="column is-6-tablet is-2-desktop relative">
                <datepicker v-model="filters.date" @update:modelValue="fetchPaginatedData()"   placeholder="Due Date" />
            </div>
            <div class="column is-6-tablet is-2-desktop">
                <o-field>
                    <o-select placeholder="Location" v-model="filters.location" :expanded="true" @update:modelValue="fetchPaginatedData(true)">
                        <option value="specified">Select Location</option>
                        <option v-for="location in taskLocations" :value="location.id" :key="location.id">{{ location.name }}</option>
                    </o-select>
                </o-field>
            </div>
            <div class="column is-6-tablet is-2-desktop">
                <o-field>
                    <multicomplete v-model="statuses" :value="statuses" type="custom" placeholder="Status" :is-object="true" :optionsProp="taskStatuses" fieldName="name" />
                </o-field>
            </div>
            <div class="column is-offset-4 is-4-tablet is-2-desktop has-text-right">
                <div class="field">
                    <o-checkbox v-model="filters.is_package_log" :true-value="1" :false-value="0" @update:modelValue="fetchPaginatedData()">View package logs</o-checkbox>
                </div>
            </div>
        </div>
        <o-table
                class="fullwidth-table is-responsive is-responsive-wide"

                v-if="isTableVisible"
                :data="paginatedData"

                :bordered="table.bordered"
                :striped="table.striped"
                :narrowed="table.narrowed"
                :checkable="table.checkable"
                :mobile-cards="table.mobileCards"
                :paginated="table.paginated"
                :pagination-simple="table.paginationSimple"
                :per-page="table.perPage"
                :default-sort="table.defaultSort"

                :selected.sync="selected"
                :checked-rows.sync="checkedRows"

                :loading="loading"
                :total="total"
                backend-sorting
                backend-pagination
                @page-change="onPageChange"
                @sort="onSort"
        >
            <template>
                <template v-for="col in tableColumns">
                    <o-table-column
                            :field="col.field"
                            :label="col.field === 'actions' ? '' : col.label"
                            :sortable="col.sortable"
                            #default="{ row }"
                    >
                        <task-column v-if="col.field !== 'actions'" :field="col.field" :item="row" :project-id="null" />

                        <o-dropdown v-if="col.field === 'actions'" hoverable position="bottom-left" class="table-actions">
                          <template #trigger>
                            <button class="button">
                              <o-icon pack="fa" icon="ellipsis-v"></o-icon>
                            </button>
                          </template>
                            <o-dropdown-item has-link><a @click="openReplyModal(row.id)">Reply</a></o-dropdown-item>
                            <o-dropdown-item has-link><a @click="openPreviewModal(row)">Print</a></o-dropdown-item>
                            <o-dropdown-item has-link><router-link :to="{ name: 'tasks.show', params: { slug: row.id }, query: {project_id: null} }">View Task</router-link></o-dropdown-item>
                            <o-dropdown-item has-link><a @click="openReminderModal(row.id)">Set Reminder</a></o-dropdown-item>
                        </o-dropdown>
                    </o-table-column>
                </template>
            </template>

          <template #empty>
            <div class="has-text-centered">
              This table is empty!
            </div>
          </template>
        </o-table>

       <o-modal :can-cancel="['escape', 'outside', 'button']" scroll="keep" v-model:active="isReminderModalActive" has-modal-card>
            <reminder-modal :reference-id="taskId" reference-type="task"/>
        </o-modal>
        <!--<o-modal :can-cancel="['escape', 'outside', 'button']" scroll="keep" :active.sync="isCalendarModalActive" class="calendar-modal" has-modal-card>-->
            <!--<calendar-modal :project-id="null"/>-->
        <!--</o-modal>-->
       <o-modal :can-cancel="['escape', 'outside', 'button']" scroll="keep" v-model:active="isReplyModalActive" has-modal-card>
            <reply-modal :reference-id="taskId" reference-type="task"/>
        </o-modal>
       <o-modal :can-cancel="['escape', 'outside', 'button']" scroll="keep" v-model:active="isPreviewModalActive" class="preview-modal" has-modal-card>
            <preview-modal :file="currentPreviewFile"/>
        </o-modal>
       <o-modal :can-cancel="['escape', 'outside', 'button']" scroll="keep" v-model:active="isTableSettingsModalActive" has-modal-card class="table-settings-modal">
            <table-settings-modal :slug="tableName"/>
        </o-modal>
    </div>
</template>

<script>
    import Table from '../../../mixins/Table'
    import { mapActions, mapGetters } from 'vuex'
//    import CalendarModal from './../../../components/modals/Calendar'
    import TaskColumn from './../../../components/table-columns/Task'
    import Datepicker from './../../../components/Datepicker'
    import PreviewModal from './../../../components/modals/Preview'

    export default {
        mixins: [Table],

        components: {
            /*CalendarModal, */TaskColumn, Datepicker, PreviewModal
        },

        data () {
            return {
                tableName: 'tasks-by-location',
                // table: {
                //     defaultSort: ['created_at', 'desc']
                // },
                taskId: null,
                isPreviewModalActive: false,
//                isCalendarModalActive: false,
                isReminderModalActive: false,
                isReplyModalActive: false,
                currentPreviewFile: null,
                filters: {
                    // project_id: this.projectId,
                    is_package_log: 0,
                    assignee_id: '',
                    category_id: '',
                    title: '',
                    date: '',
                    type: '',
                    location: 'specified',
                    statuses: []
                },
                taskLocations: [],
            }
        },

        computed: {
            ...mapGetters([
                'latestNoteMessageByTaskId',
                'categoryNameById',
                'projectNameById',
                'taskStatuses',
                'userNameById',
                'taskTypes',
                'taskByLocationDefaultStatuses'
            ]),

            ...mapGetters({
                itemsByIds: 'tasksByIds'
            }),

            newTaskRoute() {
                return { name: 'tasks.create', query: {project_id: this.projectId} }
            },

            isResetFiltersButtonVisible() {
                let f = this.filters

                return f.title || f.type || f.assignee_id || f.project_id || f.category_id || f.date || f.is_package_log || f.location != 'specified' || f.statuses.length > 0
            },
            statuses: {
                get() {
                    this.filters.statuses = _.map(this.filters.statuses, p => +p)
                    return _.filter(this.taskStatuses, status => {
                        return this.filters.statuses.includes(status.id)
                    })
                }, 
                set(value){
                    this.filters.statuses = _.map(value, 'id')
                    this.fetchPaginatedData(true)
                }
            }
        },
        mounted () {
            this.statuses = this.taskByLocationDefaultStatuses
            this.fetchTaskBasedCompanies().then(res => {
                this.taskLocations = res.data.data
            })
            this.fetchPaginatedData()
        },

        methods: {
            ...mapActions({
                partialUpdateTask: 'partialUpdateTask',
                removeItem: 'removeTask',
                fetchData: 'fetchTasks',
                fetchTaskBasedCompanies: 'fetchTaskBasedCompanies',
            }),

            handleResetFilters() {
                for (let field in this.visibleFilters) {
                    this.filters[field] = _.isArray(this.filters[field]) ? [] : ''
                }
                this.filters.location = 'specified'
                if(this.table.paginated) {
                    this.fetchPaginatedData(true, this.requestParams)
                }
            },

            openPreviewModal(task) {
                const port = window.location.port ? `:${window.location.port}` : ''
                this.currentPreviewFile = {
                    name: task.title,
                    mime: 'application/pdf',
                    path: `${window.location.protocol}//${window.location.hostname}${port}/tasks/${task.id}/pdf`,
                    generatedOnTheFly: true
                }
                this.isPreviewModalActive = true
            },

            openReminderModal (taskId) {
                this.isReminderModalActive = true
                this.taskId = taskId
            },

            openReplyModal (taskId) {
                this.isReplyModalActive = true
                this.taskId = taskId
            }
        }
    }
</script>

